<template>
  <div id="CancelModal">
    <div
      class="d-flex flex-column justify-content-center align-items-center w-100 px-4"
      v-if="booking"
    >
      <div
        class="px-5 py-5 d-flex flex-column justify-content-center align-items-center text-center"
      >
        <h3 v-if="title" class="section-title mt-3 text-center">{{ title }}</h3>
        <p>{{ booking.id }}</p>
        <p
          v-if="paragraphs[0]"
          class="cancel-message"
          :class="isUnableToCancel ? 'mb-4' : 'mb-0'"
        >
          {{ paragraphs[0] }}
          <a
            v-if="isUnableToCancel && !isServiceIncludedInPlan"
            href="mailto:appointments@spectrum.life."
            class="cancel-modal-link"
          >
            appointments@spectrum.life.</a
          >
        </p>
        <p v-if="paragraphs[1]" class="cancel-message mb-4">
          {{ paragraphs[1] }}
          <a
            v-if="isUnableToCancel && !isServiceIncludedInPlan"
            href="mailto:coachingappointments@spectrum.life"
            class="cancel-modal-link"
          >
            coachingappointments@spectrum.life</a
          >
        </p>
        <p v-if="paragraphs[2]" class="cancel-message mb-0">
          {{ paragraphs[2] }}
          <RouterLink
            to="/cancellation-policy"
            target="_blank"
            class="cancel-modal-link"
          >
            click here</RouterLink
          >
        </p>
        <div class="d-flex flex-column-reverse w-100 mt-5">
          <b-button
            v-if="buttonTexts[0]"
            @click="closeModal()"
            variant="cancel"
            class="cancel-button"
          >
            {{ buttonTexts[0] }}
          </b-button>
          <b-button
            v-if="buttonTexts[1]"
            variant="continue"
            class="cancel-button"
            :id="'confirm-cancel-' + booking.appointmentType + '-appt-button'"
            @click="cancelBooking(booking)"
          >
            <span v-if="!bookingCancelLoading">
              {{ buttonTexts[1] }}
            </span>
            <b-spinner
              style="width: 1.4rem; height: 1.4rem;"
              v-else
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import config from "@/config/constants";
import EventBus from "@/helpers/eventbus";

export default {
  props: ["booking"],
  name: "CancelModal",
  data() {
    return {
      bookingCancelLoading: false
    };
  },
  computed: {
    isUnableToCancel() {
      if (!this.booking || !this.booking.startTime) {
        return true;
      }

      return this.isWithin24Hours(this.booking?.startTime);
    },
    isServiceIncludedInPlan() {
      return this.booking?.serviceName === "In-The-Moment Support";
    },
    title() {
      return this.isUnableToCancel && !this.isServiceIncludedInPlan
        ? "We are unable to cancel your appointment"
        : "Are you sure you want to cancel?";
    },
    paragraphs() {
      return this.isServiceIncludedInPlan
        ? [
            "Once you cancel your appointment, you will no longer be able to attend the session"
          ]
        : this.isUnableToCancel
        ? [
            "To cancel or reschedule your appointment for Open-ended digital therapy or Neurodiversity services, please email",
            "For a coaching services, contact us at",
            "For more information on our cancellation policy, including important refund information for late cancellations,"
          ]
        : [
            "Once you cancel your appointment, you will no longer be able to attend the session",
            "A full refund will be sent within 3-5 working days following cancellation",
            "For more information on our cancellation policy"
          ];
    },
    buttonTexts() {
      return this.isUnableToCancel && !this.isServiceIncludedInPlan
        ? ["Close"]
        : ["No, Keep my session", "Yes, cancel my session"];
    }
  },
  methods: {
    isWithin24Hours(startTime) {
      const now = new Date();
      const givenDate = new Date(startTime);
      const differenceInMilliseconds = givenDate - now;

      return differenceInMilliseconds <= 24 * 60 * 60 * 1000;
    },
    closeModal() {
      this.$bvModal.hide("cancel_modal");
    },
    triggerAlert(message, success) {
      EventBus.$emit("alert", { message, success });
    },
    async cancelBooking() {
      if (this.bookingCancelLoading) {
        return;
      }
      this.bookingCancelLoading = true;
      const payload = {
        user_id: this.$store.getters.user_id,
        appointment_id: this.booking.appointmentId,
        appointment_type: this.booking.appointmentType?.toLowerCase(),
        message: "User cancelled the session"
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/dmh/cancel-appointment",
        payload,
        config.options
      );
      this.bookingCancelLoading = false;
      this.closeModal();
      if (res.data.success) {
        this.triggerAlert("Your session has been cancelled", true);
        EventBus.$emit("getBookings");
      } else {
        this.triggerAlert(
          "An error occurred while canceling your session. Please try again later.",
          false
        );
      }
    }
  }
};
</script>
<style lang="less">
#digital_clinics_modal___BV_modal_outer_ {
  z-index: 1000000 !important;

  * {
    scrollbar-width: thin;
    scrollbar-color: #aaa;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 8px;
  }

  *::-webkit-scrollbar-track {
    background: rbga(0, 0, 0, 0);
    margin: 10px;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 10px;
    border: 5px none #ffffff;
    opacity: 0;
  }

  .hidden-link {
    opacity: 0;
    cursor: pointer;
  }
}

#cancel_modal {
  .section-title {
    text-align: center;
    font-size: 2.2rem;
    letter-spacing: 0;
    margin-bottom: 16px;
    font-family: "PlusJakartaSansBold";
  }
  .cancel-modal-link {
    font-family: "PlusJakartaSansBold";
    color: #3c16f9;

    &:hover {
      color: #3c16f9;
    }
  }
  div {
    font-size: 1.6rem;
    border-radius: 16px;
    max-width: 460px;
    b {
      font-family: "PlusJakartaSansBold";
    }
  }
  .cancel-message {
    font-size: 1.6rem;
    line-height: 2.2rem;
  }
  .btn.btn-continue {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #192550;
    min-width: 100%;
    min-height: 64px;
    border-radius: 8px !important;
    padding: 20px;
    color: #fff;
    font-size: 1.6rem !important;
    letter-spacing: 0 !important;
    line-height: 2.2rem !important;
    margin: 0 auto 20px;

    &:hover,
    &:focus {
      color: #fff;
      background-color: #009577;
    }
  }
  .btn.btn-cancel {
    border: 1px solid rgba(30, 30, 34, 0.4) !important;
    padding: 20px;
    min-width: 100%;
    min-height: 64px;
    border-radius: 8px !important;
    font-size: 1.6rem !important;
    letter-spacing: 0 !important;
    color: #192550;

    &:hover,
    &:focus {
      background-color: rgba(25, 37, 80, 0.05);
    }
  }
}
</style>
